import { render, staticRenderFns } from "./dresscode.vue?vue&type=template&id=4f0ee98f"
import script from "./dresscode.vue?vue&type=script&lang=js"
export * from "./dresscode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports